import { api } from '../api';

export const get = (type: BannerType) => api.get('/banners', { params: { type } });

export const getIsoInstruction = () => api.get('/instructions/iso', { responseType: 'blob' });

export const getInstruction = (type: string) => api.get('/instructions', { params: { type }, responseType: 'blob' });
